import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getWarehouses } from '../reports/ReportsFunctions'

const findProduct = async (app, product) => {
    /** Replace % sympbol with url encoding %25 to prevent malformed url encoding error */
    const brand = product.brand.replace("%", "%25")
    const name = product.name.replace("%", "%25")
    const description = product.description.replace("%", "%25")
    const result = await axios.get(app.API_URI + `/products?brand=${brand}&name=${name}&description=${description}`)
    /** If the result has data and the is the same then consider it ok because it's an update action
     *  If the result's data is however have different _id then it means it is trying to update the product
     *  but has found similar
    */
    console.log(result?.data._id, product._id)
    if (result?.data._id === product._id) return null
    return result.data
}

export const saveProduct = async (app, product) => {
    let saved_product = null
    const product_found = await findProduct(app, product)
    if (product_found) return -1 // Product exist

    app.startLoadingIndicator("Saving product")

    delete product.brand_error
    delete product.name_error
    delete product.description_error
    delete product.classification_error

    // New Product
    if (!product._id) {
        await trackPromise (
            axios.post(app.API_URI + `/products`, product)
            .then(result => {
                saved_product = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    // Update Existing
    } else {
        await trackPromise (
            axios.put(app.API_URI + `/products?product_id=${product._id}`, product)
            .then(result => {
                saved_product = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return saved_product
}

export const getProductById = async (app, product_id) => {
    let product = null
    app.startLoadingIndicator("Loading product info")
    await trackPromise (
        axios.get(app.API_URI + `/products?product_id=${product_id}`)
        .then(result => {
            product = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return product
}

export const getProductsList = async (app, warehouse_id, silent=false) => {
    let products_list = null
    if (!silent) app.startLoadingIndicator("Reloading products")
    if (warehouse_id)
        await trackPromise (
            axios.get(app.API_URI + `/products?warehouse_id=${warehouse_id}`)
            .then(result => {
                products_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    else
        await trackPromise (
            axios.get(app.API_URI + `/products`)
            .then(result => {
                products_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )

    return products_list
}

export const getProductsListSettings = async (app) => {
    let products_list_settings = null 
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/settings?user_id=${user_id}&field=products_list`)
        .then(result => {
            products_list_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return products_list_settings
}

export const saveSettings = async (app, settings) => {
    let save_settings = null
    if (settings.rpp === '' || settings.rpp === 0) settings.rpp = 25 // If invalid rpp then set it to default
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator("Saving settings")
    await trackPromise (
        axios.put(app.API_URI + `/settings?user_id=${user_id}&field=products_list`, settings)
        .then(result => {
            save_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return save_settings
}

export const deleteProduct = async (app, product_id) => {
    let delete_product = null
    app.startLoadingIndicator("Deleting record")
    await trackPromise (
        axios.delete(app.API_URI + `/products?product_id=${product_id}`)
        .then(result => {
            delete_product = result.data
            app.stopLoadingIndicator() 
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return delete_product
}

export const findAndReplaceItem = async (app, field, from_to) => {
    let rec_updated = 0;

    app.startLoadingIndicator("Deleting record")
    if (from_to) {
        await trackPromise (
            axios.put(app.API_URI + `/products?replace_field=${field}`, from_to)
            .then(result => {
                rec_updated = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return (rec_updated)
}

export { getWarehouses }